var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "grid queue-item",
        class: _vm.innerClasses,
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.handleClick($event, _vm.item.id)
          }
        }
      },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _vm.divider
      ? _c("div", { staticClass: "wo-divider--dots" }, [
          _c("span", {
            staticClass: "glyphicon glyphicon-option-horizontal",
            attrs: { "aria-hidden": "true" }
          })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }